var render, staticRenderFns
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed8f375e')) {
      api.createRecord('ed8f375e', component.options)
    } else {
      api.reload('ed8f375e', component.options)
    }
    
  }
}
component.options.__file = "src/views/dms/views/order/need_goods_detail/table.vue"
export default component.exports